import type { ReactNode } from 'react'

import type { OrganizationRoleKey } from '@/components/org-settings/members/members.interface'
import { MembersTabsContent } from '@/components/org-settings/members/members-tabs-content.organism'
import { SeatUsageAlert } from '@/components/org-settings/members/seat-usage-alert.atom'

import { LeaveOrganizationButton } from './leave-organization-button.atom'
import { MembersToolbarAction } from './members-toolbar-action.atom'
import type { UseMembersSettingsReturn } from './use-members-settings.hook'

interface MembersContentSectionProps {
  settings: UseMembersSettingsReturn
  subscriptionHref: string
  onRoleChange: (memberId: string, memberRole: OrganizationRoleKey) => void
  onRemoveMember: (memberId: string | null) => void
  onRevokeInvitation: (invitationId: string | null) => void
  onInviteClick: () => void
  onLeaveClick: () => void
}

export const MembersContentSection: React.FC<MembersContentSectionProps> = ({
  settings,
  subscriptionHref,
  onRoleChange,
  onRemoveMember,
  onRevokeInvitation,
  onInviteClick,
  onLeaveClick,
}): ReactNode => (
  <>
    <SeatUsageAlert
      currentCount={settings.currentMemberCount}
      maxCount={settings.maxAllowedMembers}
      subscriptionHref={subscriptionHref}
    />
    <MembersTabsContent
      memberList={settings.memberList}
      invitationList={settings.invitationList}
      currentUserId={settings.currentUserId}
      canManageMembers={settings.canManageMembers}
      isMembersLoading={settings.isMembersLoading}
      isInvitationsLoading={settings.isInvitationsLoading}
      onRoleChange={onRoleChange}
      onRemoveMember={onRemoveMember}
      onRevokeInvitation={onRevokeInvitation}
      toolbarActions={
        settings.canManageMembers && (
          <MembersToolbarAction onClick={onInviteClick} isDisabled={settings.isAtMemberLimit} />
        )
      }
    />
    {!settings.canManageMembers && <LeaveOrganizationButton onClick={onLeaveClick} />}
  </>
)

MembersContentSection.displayName = 'MembersContentSection'
